// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Flex } from '../../../../grid';
import { breakpointsToArray } from '../../../../../helpers';
import {
  Label,
  FormRow,
  ReduxFormRadio,
} from '../../../../form';
import { Text } from '../../../../form/labelText';
import ReduxFormField from '../../../../form/reduxFormField';
import { getFormSettings } from '../../../../../store/formSettings/selectors';

type OwnProps = {|
  label: string,
  name: string,
  salutation_male: ?string, // eslint-disable-line react/no-unused-prop-types
  salutation_female: ?string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  salutationMale: string,
  salutationFemale: string,
|};

type Props = OwnProps & StateProps;

const SalutationField = ({
  label,
  name,
  salutationMale,
  salutationFemale,
}: Props) => (
  <FormRow>
    <Label>
      <Flex width={6 / 12}><Text>{label}</Text></Flex>
      <Flex width={breakpointsToArray({ default: 1, sm: 8 / 12 })}>
        <Flex pr="1em" width={4 / 12}>
          <Label>
            <ReduxFormField
              name={name}
              component={ReduxFormRadio}
              type="radio"
              value="mvr" // @todo which value to pick?// @todo which value to pick?
            />
            {salutationFemale}
          </Label>
        </Flex>
        <Flex pr="1em" width={4 / 12}>
          <Label>
            <ReduxFormField
              name={name}
              component={ReduxFormRadio}
              type="radio"
              value="dhr"
            />
            {salutationMale}
          </Label>
        </Flex>
      </Flex>
    </Label>
  </FormRow>
);

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  salutationMale: ownProps.salutation_male || getFormSettings(state).salutation_male,
  salutationFemale: ownProps.salutation_female || getFormSettings(state).salutation_female,
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(SalutationField);
